<p-dialog
  [visible]="visible()"
  (visibleChange)="onDialogVisibilityChange($event)"
  [header]="dialogHeader()"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="tf-settings-area-form-dialog"
  [style]="{ width: '900px', maxWidth: '95vw' }"
  [breakpoints]="{ '960px': '95vw' }">
  <div class="tabs-strip" role="tablist">
    <button
      type="button"
      role="tab"
      class="tab"
      [class.active]="activeTab() === 'draw'"
      [attr.aria-selected]="activeTab() === 'draw'"
      (click)="onTabChange('draw')">
      <i class="pi pi-pencil" aria-hidden="true"></i>
      <span>{{ 'SETTINGS_AREAS.DIALOG.TAB_DRAW' | translate }}</span>
    </button>
    <button
      type="button"
      role="tab"
      class="tab"
      [class.active]="activeTab() === 'upload'"
      [attr.aria-selected]="activeTab() === 'upload'"
      (click)="onTabChange('upload')">
      <i class="pi pi-upload" aria-hidden="true"></i>
      <span>{{ 'SETTINGS_AREAS.DIALOG.TAB_UPLOAD' | translate }}</span>
    </button>
  </div>

  <div class="dialog-2col">
    <div class="form-col">
      <div class="field">
        <label class="field-label-strong" for="area-name">
          {{ 'SETTINGS_AREAS.FORM.NAME' | translate }}
        </label>
        <input
          pInputText
          id="area-name"
          type="text"
          class="w-full"
          [maxlength]="maxNameLength"
          [ngModel]="formModel().name"
          (ngModelChange)="onNameChange($event)"
          [attr.aria-invalid]="
            serverErrors.get('name') || (areaForm.name().invalid() && areaForm.name().touched())
              ? true
              : null
          " />
        <div class="char-counter">
          @if (serverErrors.get('name'); as nameError) {
            <span class="field-error">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
              {{ nameError }}
            </span>
          } @else if (areaForm.name().invalid() && areaForm.name().touched()) {
            <span class="field-error">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
              {{
                areaForm.name().errors()[0]?.message ?? 'SETTINGS_AREAS.FORM.NAME_REQUIRED'
                  | translate
              }}
            </span>
          } @else {
            <span></span>
          }
          <span>{{ formModel().name.length }}/{{ maxNameLength }}</span>
        </div>
      </div>

      <div class="field">
        <label class="field-label-strong" for="area-description">
          {{ 'SETTINGS_AREAS.FORM.DESCRIPTION' | translate }}
          <span class="field-optional">· {{ 'SETTINGS_AREAS.FORM.OPTIONAL' | translate }}</span>
        </label>
        <textarea
          pTextarea
          id="area-description"
          rows="3"
          class="w-full"
          [autoResize]="false"
          [maxlength]="maxDescriptionLength"
          [ngModel]="formModel().description"
          (ngModelChange)="onDescriptionChange($event)"></textarea>
        <div class="char-counter">
          @if (serverErrors.get('description'); as descError) {
            <span class="field-error">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
              {{ descError }}
            </span>
          } @else {
            <span></span>
          }
          <span>{{ formModel().description.length }}/{{ maxDescriptionLength }}</span>
        </div>
      </div>

      <div class="field">
        <label class="field-label-strong" for="area-color">
          {{ 'SETTINGS_AREAS.FORM.COLOR' | translate }}
        </label>
        <div class="color-row">
          <span
            class="color-swatch-btn"
            [style.background]="formModel().color"
            [attr.aria-label]="'SETTINGS_AREAS.FORM.COLOR' | translate"></span>
          <input
            pInputText
            id="area-color"
            class="w-full color-hex-input"
            type="text"
            [ngModel]="formModel().color.toUpperCase()"
            (ngModelChange)="onColorInputChange($event)" />
        </div>
        <div
          class="color-presets"
          role="radiogroup"
          [attr.aria-label]="'SETTINGS_AREAS.FORM.COLOR' | translate">
          @for (preset of presetColors; track preset) {
            <button
              type="button"
              class="color-preset"
              role="radio"
              aria-checked="false"
              [class.selected]="preset.toUpperCase() === formModel().color.toUpperCase()"
              [attr.aria-checked]="preset.toUpperCase() === formModel().color.toUpperCase()"
              [style.background]="preset"
              [attr.aria-label]="preset"
              [title]="preset"
              (click)="pickColor(preset)">
              @if (preset.toUpperCase() === formModel().color.toUpperCase()) {
                <i class="pi pi-check" aria-hidden="true"></i>
              }
            </button>
          }
        </div>
        @if (serverErrors.get('color'); as colorError) {
          <span class="field-error">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ colorError }}
          </span>
        }
      </div>

      <div class="advanced-section">
        <button
          type="button"
          class="advanced-header"
          [class.open]="advancedOpen()"
          [attr.aria-expanded]="advancedOpen()"
          (click)="toggleAdvanced()">
          <i class="pi pi-chevron-down" aria-hidden="true"></i>
          <span>{{ 'SETTINGS_AREAS.FORM.ADVANCED' | translate }}</span>
        </button>
        @if (advancedOpen()) {
          <div class="advanced-body">
            <span class="field-label-strong field-label-sm">
              {{ 'SETTINGS_AREAS.FORM.ZIP_RANGES' | translate }}
              @if (geocodingCentroid()) {
                <span class="zip-country-pill zip-country-pill--loading">
                  {{ 'SETTINGS_AREAS.FORM.ZIP_RESOLVING' | translate }}
                </span>
              }
            </span>
            @if (formModel().zipRanges.length > 0) {
              <div
                class="zip-list"
                role="list"
                [attr.aria-label]="'SETTINGS_AREAS.FORM.ZIP_RANGES' | translate">
                @for (range of formModel().zipRanges; track $index) {
                  <div class="zip-row" role="listitem">
                    <p-select
                      styleClass="zip-row__country"
                      appendTo="body"
                      [options]="countryOptions()"
                      optionLabel="label"
                      optionValue="iso3"
                      [filter]="true"
                      filterBy="label,iso3"
                      [placeholder]="'SETTINGS_AREAS.FORM.ZIP_COUNTRY' | translate"
                      [attr.aria-label]="'SETTINGS_AREAS.FORM.ZIP_COUNTRY' | translate"
                      [ngModel]="range.country ?? null"
                      (ngModelChange)="updateZipRangeCountry($index, $event)" />
                    <input
                      pInputText
                      class="zip-row__from"
                      type="text"
                      autocomplete="off"
                      [attr.aria-label]="'SETTINGS_AREAS.FORM.ZIP_FROM' | translate"
                      [title]="'SETTINGS_AREAS.FORM.ZIP_FROM' | translate"
                      [placeholder]="'SETTINGS_AREAS.FORM.ZIP_FROM' | translate"
                      [ngModel]="range.from ?? ''"
                      (ngModelChange)="updateZipRangeFrom($index, $event)" />
                    <span class="zip-row__sep" aria-hidden="true">–</span>
                    <input
                      pInputText
                      class="zip-row__to"
                      type="text"
                      autocomplete="off"
                      [attr.aria-label]="'SETTINGS_AREAS.FORM.ZIP_TO' | translate"
                      [title]="'SETTINGS_AREAS.FORM.ZIP_TO' | translate"
                      [placeholder]="'SETTINGS_AREAS.FORM.ZIP_TO' | translate"
                      [ngModel]="range.to ?? ''"
                      (ngModelChange)="updateZipRangeTo($index, $event)" />
                    <button
                      type="button"
                      class="zip-row__remove"
                      [attr.aria-label]="'SETTINGS_AREAS.FORM.ZIP_REMOVE' | translate"
                      [title]="'SETTINGS_AREAS.FORM.ZIP_REMOVE' | translate"
                      (click)="removeZipRange($index)">
                      <i class="pi pi-times" aria-hidden="true"></i>
                    </button>
                  </div>
                }
              </div>
            }
            <button
              type="button"
              class="zip-add-btn"
              [title]="
                canAddZipRange()
                  ? ('SETTINGS_AREAS.FORM.ZIP_ADD' | translate)
                  : ('SETTINGS_AREAS.FORM.ZIP_COUNTRY_NEEDED' | translate)
              "
              [disabled]="!canAddZipRange()"
              [attr.aria-disabled]="!canAddZipRange() || null"
              (click)="addZipRange()">
              <i class="pi pi-plus" aria-hidden="true"></i>
              <span>{{ 'SETTINGS_AREAS.FORM.ZIP_ADD' | translate }}</span>
            </button>
            @if (zipRangesServerError(); as zipError) {
              <span class="field-error" role="alert">
                <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
                {{ zipError }}
              </span>
            } @else {
              <div class="field-helper">
                @if (!derivedCountryIso3() && !geocodingCentroid()) {
                  {{ 'SETTINGS_AREAS.FORM.ZIP_COUNTRY_NEEDED' | translate }}
                } @else {
                  {{ 'SETTINGS_AREAS.FORM.ZIP_HELPER' | translate }}
                }
              </div>
            }
          </div>
        }
      </div>

      @if (activeTab() === 'draw') {
        <p class="saving-hint">{{ 'SETTINGS_AREAS.DIALOG.SAVING_HINT' | translate }}</p>
      }
    </div>

    <div class="map-col">
      @if (activeTab() === 'draw') {
        <div class="map-workspace">
          <tf-mapbox-map
            [scrollZoom]="true"
            [navigationControl]="false"
            (mapLoad)="onMapLoad($event)" />
          <div class="map-helper">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            <span>{{ 'SETTINGS_AREAS.DIALOG.DRAW_HELPER' | translate }}</span>
          </div>

          <div
            class="map-tools"
            role="toolbar"
            [attr.aria-label]="'SETTINGS_AREAS.TOOLS.LABEL' | translate">
            <button
              type="button"
              class="map-tool-btn"
              [class.active]="drawMode() === 'add'"
              [pTooltip]="'SETTINGS_AREAS.TOOLS.DRAW' | translate"
              tooltipPosition="left"
              [attr.aria-label]="'SETTINGS_AREAS.TOOLS.DRAW' | translate"
              [title]="'SETTINGS_AREAS.TOOLS.DRAW' | translate"
              [attr.aria-pressed]="drawMode() === 'add'"
              (click)="setDrawMode('add')">
              <i class="pi pi-pencil" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="map-tool-btn"
              [class.active]="drawMode() === 'edit'"
              [disabled]="!hasGeometry()"
              [pTooltip]="'SETTINGS_AREAS.TOOLS.EDIT' | translate"
              tooltipPosition="left"
              [attr.aria-label]="'SETTINGS_AREAS.TOOLS.EDIT' | translate"
              [title]="'SETTINGS_AREAS.TOOLS.EDIT' | translate"
              [attr.aria-pressed]="drawMode() === 'edit'"
              (click)="setDrawMode('edit')">
              <i class="pi pi-arrows-alt" aria-hidden="true"></i>
            </button>
            <span class="map-tool-divider"></span>
            <button
              type="button"
              class="map-tool-btn map-tool-btn--danger"
              [disabled]="!hasGeometry()"
              [pTooltip]="'SETTINGS_AREAS.TOOLS.CLEAR' | translate"
              tooltipPosition="left"
              [attr.aria-label]="'SETTINGS_AREAS.TOOLS.CLEAR' | translate"
              [title]="'SETTINGS_AREAS.TOOLS.CLEAR' | translate"
              (click)="clearDrawing()">
              <i class="pi pi-trash" aria-hidden="true"></i>
            </button>
            <span class="map-tool-divider"></span>
            <button
              type="button"
              class="map-tool-btn"
              [pTooltip]="'SETTINGS_AREAS.TOOLS.ZOOM_IN' | translate"
              tooltipPosition="left"
              [attr.aria-label]="'SETTINGS_AREAS.TOOLS.ZOOM_IN' | translate"
              [title]="'SETTINGS_AREAS.TOOLS.ZOOM_IN' | translate"
              (click)="zoomIn()">
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="map-tool-btn"
              [pTooltip]="'SETTINGS_AREAS.TOOLS.ZOOM_OUT' | translate"
              tooltipPosition="left"
              [attr.aria-label]="'SETTINGS_AREAS.TOOLS.ZOOM_OUT' | translate"
              [title]="'SETTINGS_AREAS.TOOLS.ZOOM_OUT' | translate"
              (click)="zoomOut()">
              <i class="pi pi-minus" aria-hidden="true"></i>
            </button>
          </div>

          @if (mapBadgeText(); as badgeText) {
            <div class="map-badge">
              <span class="dot" [style.background]="formModel().color"></span>
              <span>{{ badgeText }}</span>
              @if (mapBadgeSubtext(); as subtext) {
                <span class="sep"></span>
                <span class="muted">{{ subtext }}</span>
              }
            </div>
          }
        </div>
        @if (geometryServerError(); as geoError) {
          <p class="geometry-error" role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <span>{{ geoError }}</span>
          </p>
        }
      } @else {
        <label
          class="upload-zone"
          [class.drag-over]="isDragOver()"
          [class.error]="uploadError() !== null"
          (dragenter)="onDragEnter($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <input
            type="file"
            accept=".geojson,.json,application/geo+json,application/json"
            (change)="onFilePickerChange($event)"
            class="visually-hidden" />
          <div class="upload-icon">
            @if (uploadError()) {
              <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            } @else {
              <i class="pi pi-cloud-upload" aria-hidden="true"></i>
            }
          </div>
          @if (uploadError()) {
            <h3>{{ 'SETTINGS_AREAS.UPLOAD.ERROR_TITLE' | translate }}</h3>
            @if (uploadedFile(); as f) {
              <div class="filename-row">
                <i class="pi pi-file" aria-hidden="true"></i>
                <span>{{ f.name }}</span>
                <span class="file-size">· {{ (f.size / 1024).toFixed(0) }} KB</span>
                <button
                  type="button"
                  class="filename-row__remove"
                  [attr.aria-label]="'SETTINGS_AREAS.UPLOAD.DISMISS' | translate"
                  [title]="'SETTINGS_AREAS.UPLOAD.DISMISS' | translate"
                  (click)="$event.preventDefault(); $event.stopPropagation(); dismissUploadError()">
                  <i class="pi pi-times" aria-hidden="true"></i>
                </button>
              </div>
            }
            <p class="upload-error-message">{{ uploadErrorMessage() }}</p>
            <p class="upload-error-tip">{{ 'SETTINGS_AREAS.UPLOAD.TIP' | translate }}</p>
            <span class="browse-cta">
              <i class="pi pi-upload" aria-hidden="true"></i>
              {{ 'SETTINGS_AREAS.UPLOAD.CHOOSE_DIFFERENT' | translate }}
            </span>
          } @else if (isDragOver()) {
            <h3>{{ 'SETTINGS_AREAS.UPLOAD.DROP_TITLE' | translate }}</h3>
            <p>{{ 'SETTINGS_AREAS.UPLOAD.DROP_HINT' | translate }}</p>
            <div class="requirements">
              <strong>{{ 'SETTINGS_AREAS.UPLOAD.ACCEPTED_FORMAT_TITLE' | translate }}</strong>
              <span>{{ 'SETTINGS_AREAS.UPLOAD.ACCEPTED_FORMAT_BODY' | translate }}</span>
            </div>
          } @else {
            <h3>{{ 'SETTINGS_AREAS.UPLOAD.DEFAULT_TITLE' | translate }}</h3>
            <p>{{ 'SETTINGS_AREAS.UPLOAD.DEFAULT_HINT' | translate }}</p>
            <div class="requirements">
              <strong>{{ 'SETTINGS_AREAS.UPLOAD.ACCEPTED_FORMAT_TITLE' | translate }}</strong>
              <span>{{ 'SETTINGS_AREAS.UPLOAD.ACCEPTED_FORMAT_BODY' | translate }}</span>
            </div>
          }
        </label>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      type="button"
      severity="secondary"
      [text]="true"
      [label]="'SETTINGS_AREAS.ACTIONS.CANCEL' | translate"
      (onClick)="onCancel()" />
    <p-button
      type="button"
      [label]="primarySubmitLabel()"
      [loading]="saving()"
      [disabled]="!hasGeometry() || !areaForm().valid() || saving()"
      (onClick)="submit()" />
  </ng-template>
</p-dialog>
